export default function truncate(value: string, threshold = 120): string {
  const elipsis = '...'

  if (typeof value !== 'string') return ''

  return value.length > threshold
    ? value.slice(0, threshold - elipsis.length).trim() + elipsis
    : value
}
